'use client'

import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { UserType } from '@/entities/user'
import { Link } from '@/shared/i18n'
import { useFormatDate } from '@/shared/lib'
import { MobileLayout } from '@/shared/ui'

import { useNoticesInfinite } from '../../api/get-notices-infinite'

type Props = {
  userType: UserType
}

export const MobileNoticeList = ({ userType }: Props) => {
  const { formatDate } = useFormatDate()
  const { notices, hasNextPage, fetchNextPage } = useNoticesInfinite({
    userType,
  })

  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage()
    }
  }, [inView, hasNextPage, fetchNextPage])

  return (
    <MobileLayout className="pt-6">
      <ul className="flex grow flex-col">
        {notices.map(notice => (
          <li
            key={notice.id}
            className="group border-b border-gray-50 last:border-none"
          >
            <Link
              href={`/${userType}/notice/${notice.id}`}
              className="block py-4 group-first:pt-0 group-last:pb-0"
            >
              <div className="flex h-[42px] flex-col gap-0.5">
                <h2 className="typo-body2 line-clamp-1 grow font-medium text-gray-900">
                  {notice.title}
                </h2>
                <p className="typo-label2 font-normal text-gray-500">
                  {formatDate({ date: notice.writeDate })}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <div ref={ref} aria-hidden="true" />
    </MobileLayout>
  )
}
